import { useInfiniteQuery } from '@tanstack/react-query';
import { getWalletHistory } from '../lib/apiClient';

export function useWalletHistory(address: string, limit = 25) {
  return useInfiniteQuery({
    queryKey: ['wallet-history', address, limit],
    queryFn: ({ pageParam }) =>
      getWalletHistory(address, { cursor: pageParam ?? undefined, limit }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    staleTime: 60_000,
  });
}
